import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AlgChannelService } from "./channel.service";
import { ApiVisa } from '../../../shared/api-visa.model';
import { Core2Config } from "../../../shared";

@Injectable({ providedIn: "root" })
export class SmsService extends AlgChannelService {

  constructor(httpClient: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'twilio-api/sms/send'
    this.endpointPath =Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'twilio-api/sms/send'
    this.httpClient = httpClient;
  }

  broadcastSms(data: any, apiVisa: ApiVisa) {
    let url = this.apiUrl + '/broadcast';
    return this.httpClient.post(
      url,
      data,
      this.getMultiPartFormHttpHeader(apiVisa)
    );
  }

}
